/*
 * @Author: huangzq
 * @Date: 2020-04-14 11:12:14
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-04-14 11:20:10
 * @Desc: 状态单选组件
*/
<template>
  <mk-radio-group
    :value="value"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <mk-radio
      v-for="(item,index) in data"
      :key="index"
      :label="item.value"
    >
      {{ item.label }}
    </mk-radio>
  </mk-radio-group>
</template>

<script>
export default {
  name: 'StatusRadio',
  props: {
    value: {
      type: [String, Number, Boolean],
      default: ''
    },
    data: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>
